import { Divider, Button, Breadcrumb, Layout } from "antd";
import { useNavigate } from "react-router-dom";
import { ViewVisitor } from "./ViewVisitor";
import { Footers } from "../../Footers";

export const DetailVisior = () => {
  //   const { user } = useContext(UserContext);
  const navigate = useNavigate();
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f6f8fa",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          maxWidth: 900,
          margin: "40px auto 0 auto",
          padding: "24px 32px 32px 32px",
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
        }}
      >
        <Breadcrumb style={{ marginBottom: 24 }}>
          <Breadcrumb.Item>
            <a
              style={{ color: "#41B3A2", fontWeight: 500 }}
              onClick={() => navigate("/")}
            >
              Home
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item style={{ fontWeight: 600 }}>
            Detail Visitor
          </Breadcrumb.Item>
        </Breadcrumb>
        <Divider style={{ margin: "0 0 24px 0" }}>
          <span style={{ fontSize: 22, fontWeight: 700, color: "#088395" }}>
            Visitor Information
          </span>
        </Divider>
        <div
          style={{
            padding: "16px 0",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 700,
              background: "#f9fafb",
              borderRadius: 12,
              boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
              padding: "32px 24px",
            }}
          >
            <ViewVisitor />
          </div>
        </div>
      </div>
      <div style={{ textAlign: "center", margin: "32px 0 0 0", color: "#888" }}>
        {/* <Footers /> */}
        {/* <span style={{ fontSize: 13 }}>
          © {new Date().getFullYear()} CGP CAMINO GERENAL PLATFORM
        </span> */}
        <Footers />
      </div>
    </div>
  );
};
